export default class {
    #baseUrl = 'https://city-map.innsbruck.gv.at/stadtplan/'
    #mapView
    #searchQueryString
    #searchType
    #idFilters = []
    #idSearch = null
    #districtFilter
    #sportsTypeFilter
    #kindergartenSeatsAvailableFilter
    #toiletCostsFreeFilter = null
    #toiletBarrierFreeFilter = null
    #searchQueries = []
    #filterQueries = []
    #scale = null

    constructor(mapView) {
        this.#mapView = mapView
    }

    getMapUrl() {
        const url = this.#getUrl(true)

        console.log('generated map url: ', url)

        return url
    }

    getDataUrl() {
        let url = this.#getUrl(false);

        console.log('generated data url: ', url)

        return url
    }

    #getParams(isMapUrl = true) {
        let params

        if (isMapUrl) {
            params = Object.assign(this.#getMapUrlParams())
        } else {
            params = Object.assign(this.#getDataUrlParams())
        }

        params = Object.assign(params, this.#getCommonParams())

        params = Object.assign(params, this.#getSearchAndFilterAsNumberedParams(isMapUrl))

        return params
    }

    #addFilterQuery(type, keyname, keyvalue) {
        this.#filterQueries.push({
            'filter': type,
            'keyname': keyname,
            'keyvalue': keyvalue,
        })
    }

    #addSearchQuery(type, keyname, keyvalue, returnkey) {
        this.#searchQueries.push({
            'query': type,
            'keyname': keyname,
            'keyvalue': keyvalue,
            'returnkey': returnkey,
        })
    }

    #getSearchAndFilterAsNumberedParams(isMapUrl) {
        this.#configureQueryParameters(isMapUrl);
        let result = this.#convertQueryParametersToObject();

        this.#searchQueries = []
        this.#filterQueries = []

        return result
    }

    #configureQueryParameters(isMapUrl) {
        if (this.getSearchParam()) {
            if (this.getSearchType() === 'label') {
                this.#addFilterQuery(this.getMapView(), 'BEZEICH', '*' + this.getSearchParam() + '*')
            } else if (isMapUrl && this.getSearchType() === 'exact_address') {
                // why if isMapUrl?
                // if we leave the exact_address search for map urls as well as for data queries (for the sidebar),
                // the data query/sidebar results would be filtered by the address - which is not what we want.
                // This is because if you select one entry from the sidebar, we want to focus just this one
                // entry in the map, while keeping the whole selection available in the sidebar.
                this.#addSearchQuery('ADR', 'ADRESSE', this.getSearchParam(), 'ADRESSE')
            } else if (this.getSearchType() === 'loose_address') {
                this.#addSearchQuery('ADR', 'ADRESSE', '*' + this.getSearchParam() + '*', 'ADRESSE')
            } else if (this.getSearchType() === 'by_sprengel') {
                // If we search by sprengel, we always want the exact address,
                // because schools are always strictly assigned by "sprengel"
                // and some house numbers in a street can be in one sprengel
                // while other house numbers in a street are in another sprengel
                this.#addSearchQuery('ADR', 'ADRESSE', this.getSearchParam(), 'VS_ID')
            }
        }

        if (this.getSearchId()) {
            this.#addSearchQuery(this.getMapView(), 'ID', this.getSearchId(), 'ID')
        }

        if (this.getDistrictFilter()) {
            this.#addFilterQuery(this.getMapView(), 'STADTTEIL', this.getDistrictFilter())
        }

        if (this.getSportsTypeFilter()) {
            this.#addFilterQuery(this.getMapView(), 'SPORT_SU', '*|' + this.getSportsTypeFilter() + '|*')
        }

        if (this.getKindergartenSeatsAvailableFilter()) {
            this.#addFilterQuery(this.getMapView(), 'PLAETZE_FREI', 'ja')
        }

        if (this.getToiletCostsFreeFilter()) {
            this.#addFilterQuery(this.getMapView(), 'KOSTEN', 'kostenfrei')
        }

        if (this.getToiletBarrierFreeFilter()) {
            this.#addFilterQuery(this.getMapView(), 'BARRIERE', 'barrierefrei')
        }

        if (this.getIdFilters()) {
            this.getIdFilters().forEach(id => this.#addFilterQuery(this.getMapView(), 'ID', id))
        }

        if (!isMapUrl && !this.#searchQueries.length) {
            // The VertiGis API search needs to have at least one search query, otherwise it returns an empty result :/
            this.#addSearchQuery(this.getMapView(), 'BEZEICH', '*', 'ID')
        }
    }

    #convertQueryParametersToObject() {
        let result = {}

        const queryTotal = this.#searchQueries.length + this.#filterQueries.length

        this.#searchQueries.forEach((query, index) => {
            let number = index === 0 ? '' : index;

            result['query' + number] = query.query
            result['keyname' + number] = query.keyname
            result['keyvalue' + number] = query.keyvalue
            result['returnkey' + number] = query.returnkey
        })

        this.#filterQueries.forEach((filter, index) => {
            const totalIndex = this.#searchQueries.length + index
            let number = totalIndex === 0 ? '' : totalIndex;

            if (queryTotal > 1) {
                number++
            }

            result['filter' + number] = filter.filter
            result['keyname' + number] = filter.keyname
            result['keyvalue' + number] = filter.keyvalue
        })

        if (this.#shouldUseQueryFiltered())  {
            result['query_filtered'] = this.#mapView
        }

        if (this.#scale) {
            result['scale'] = this.#scale
        }

        return result;
    }

    #shouldUseQueryFiltered() {
        // If no query is used, we don't want to use query_filtered (otherwise we get an exception from vertiGis)
        if (!this.#searchQueries.length && !this.#filterQueries.length) {
            return false
        }

        // If we search for an address, we don't want to use query_filtered, because then the address search query would be filtered out.
        // So if we search for "Address 123" and filter for the sports type "Badminton" only the Badminton results would be displayed.
        if (this.#searchType === 'exact_address') {
            return false
        }

        // Here we have the same problem as with the exact_address search
        if (this.getSearchId()) {
            return false
        }

        return  true
    }

    #getUrl(isMapUrl) {
        let baseUrl = this.#baseUrl;

        if (isMapUrl) {
            baseUrl += 'client_mapwidget/default.jsp'
        } else {
            baseUrl += 'synservice'
        }

        const url = new URL(baseUrl)
        url.search = new URLSearchParams(this.#getParams(isMapUrl))

        return url.toString()
    }

    #getCommonParams() {
        return {
            project: 'Website_Widget',
            view: this.getMapView(),
        };
    }

    #getMapUrlParams() {
        return {
            baseURL: 'https://city-map.innsbruck.gv.at/stadtplan',
            useXD: true,
            activetools: 'NAVIGATION MAPTIP',
            startmode: 'MAPTIP',
            map_adv: true,
            callback_maptip_mw: 'maptipResult',
        }
    }

    #getDataUrlParams() {
        return {
            image_format: 'data_only',
        }
    }

    setMapView(type) {
        this.#mapView = type

        if (type === 'WC') {
            this.setToiletCostsFreeFilter(false)
            this.setToiletBarrierFreeFilter(false)
        }
    }

    getMapView() {
        return this.#mapView
    }

    setSearchParam(query) {
        this.#searchQueryString = query

        return this
    }

    getSearchParam() {
        return this.#searchQueryString || null;
    }

    setSearchType(query) {
        this.#searchType = query

        return this
    }

    getSearchType() {
        return this.#searchType || null;
    }

    setDistrictFilter(district) {
        this.#districtFilter = district

        return this
    }

    getDistrictFilter() {
        return this.#districtFilter || null
    }

    setSportsTypeFilter(sportsType) {
        this.#sportsTypeFilter = sportsType

        return this
    }

    getSportsTypeFilter() {
        return this.#sportsTypeFilter || null
    }

    setKindergartenSeatsAvailableFilter(value) {
        this.#kindergartenSeatsAvailableFilter = value

        return this
    }

    getKindergartenSeatsAvailableFilter() {
        return this.#kindergartenSeatsAvailableFilter || null
    }

    setToiletCostsFreeFilter(value) {
        this.#toiletCostsFreeFilter = value

        return this
    }

    getToiletCostsFreeFilter() {
        return this.#toiletCostsFreeFilter || null
    }

    setToiletBarrierFreeFilter(value) {
        this.#toiletBarrierFreeFilter = value

        return this
    }

    getToiletBarrierFreeFilter() {
        return this.#toiletBarrierFreeFilter || null
    }

    setIdFilters(ids) {
        this.#idFilters = ids

        return this
    }

    getIdFilters() {
        return this.#idFilters
    }

    setSearchId(id) {
        this.#idSearch = id

        return this
    }

    getSearchId() {
        return this.#idSearch
    }

    setScale(scale) {
        this.#scale = scale

        return this
    }

    getScale() {
        return this.#idSearch
    }
}
